define('models/Group',[
    'lib/lodash4',
    'lib/knockout',
    'util/ObservableModel'
], function( _, ko,ObservableModel ){
    "use strict";


    /**
     * Model that represents groups
     */
    return ObservableModel.extend({
        defaults:{
            id          : '',
            name        : '',
            memberCount : 0 ,
            type        : '',
            groupImages : [],
            selfUri     : ''
        }
    }, function(){
        var self = this;

        /**
         * Active Images associated with this group
         */
        self.activeImages = ko.computed(function () {
            var imageMap = {
                x96: "",
                x128: "",
                x150: "",
                x200: "",
                x800: "",
                x1024: ""
            };

            _.forOwn( self.groupImages(), function (imagesObservable ) {
                _.each( ko.unwrap( imagesObservable ), function(imgObj){
                    imageMap[imgObj.resolution] = imgObj.imageUri;
                });
            });

            return imageMap;
        });

        self.unwrap = function () {
            return  ObservableModel.unwrap(self, [
                "unwrap",
                "isGroup",
                'groupTypeKey'
            ]);
        };
    });


});
